import { useState } from 'react';
import { Group, Project } from '../../filters-form/types';

interface UseColumnDialogConfig {
  projects: Project[];
  groups: Group[];
  selectedCount: number;
  onAssign: (project: string, projectName: string, group: string) => void;
}

export const useAssignPostsDialog = ({
  projects,
  groups,
  selectedCount,
  onAssign,
}: UseColumnDialogConfig) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  return {
    assignPostsDialogProps: {
      isOpen,
      setIsOpen,
      projects,
      groups,
      selectedCount,
      onAssign,
    },
  };
};
